// extracted by mini-css-extract-plugin
export default {"SearchItem":"SearchItem_SearchItem__qTuaY","SearchItemText":"SearchItem_SearchItemText__PCPRv"};